import React from "react";
import { MdClose } from "react-icons/md";
import "./ModalCloseButton.css";

/**
 * Reusable close button for modals.
 * Usage: <ModalCloseButton onClick={handleClose} />
 */
const ModalCloseButton = ({ onClick, style }) => (
  <button
    type="button"
    className="modal-close-btn"
    aria-label="Close"
    onClick={onClick}
    style={style}
  >
    <MdClose />
  </button>
);

export default ModalCloseButton;
